import { ApiError, normalizeApiError } from "./errors";

export const JSON_HEADERS = Object.freeze({
  "Content-Type": "Application/json",
});

export const getApiBaseUrl = (baseUrl = process.env.REACT_APP_API_URL || "") =>
  baseUrl ? `${baseUrl.replace(/\/+$/, "")}/` : "";

export const buildApiUrl = (path, baseUrl = process.env.REACT_APP_API_URL || "") =>
  `${getApiBaseUrl(baseUrl)}${String(path).replace(/^\/+/, "")}`;

export const parseJsonResponse = async (response) => {
  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    throw new ApiError("The server could not complete the request.", {
      status: response.status,
    });
  }

  return data;
};

export const requestJson = async (path, options = {}, fetchImplementation = fetch) => {
  try {
    const response = await fetchImplementation(buildApiUrl(path), options);
    return await parseJsonResponse(response);
  } catch (error) {
    throw normalizeApiError(error);
  }
};
